<template>
  <div class="pa-4">
    <v-card color="card" class="elevation-2 rounded-lg">
      <v-card-text class="pa-0">
        <v-data-table
          :headers="contactsHeaders"
          :items="contacts"
          hide-default-footer
          disable-sort
          class="elevation-1"
          :no-data-text="getLabel('table_no_data')"
        >
          <template #[`item.birth_date`]="{ item }">
            <!-- {{ Date() }} -->
            {{ new Date(Date.parse(item.birth_date)).toLocaleDateString() }}
          </template>
          <!-- <template #item.actions="{ index }" >
            <v-btn icon @click="editContact(index)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon @click="removeContact(index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template> -->
        </v-data-table>
        <v-divider />
      </v-card-text>
    </v-card>
    <!-- <div class="d-flex justify-center mt-4">
      <v-dialog v-if="false" v-model="dialog" persistent max-width="900">
        <template #activator="{ on, attrs }">
          <v-btn x-large color="primary" dark v-bind="attrs" v-on="on">
            <v-icon>mdi-plus</v-icon>
            Add Contact
          </v-btn>
        </template>
        <v-card class="rounded-lg">
          <v-card-title class="text-h6 white--text primary ">
            Add contact
            <v-spacer />
            <v-btn icon dark @click="cancelAddContact()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-alert v-if="errors.length" type="error" class="rounded-lg mt-4" dismissible @input="closeAlert">
              <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
            </v-alert>
            <v-form ref="form" class="pt-6">
              <v-row>
                <v-col>
                  <v-text-field v-model="contactToEdit.firstname" v-bind="contactFieldsProperties('firstname')" />
                </v-col>
                <v-col>
                  <v-text-field v-model="contactToEdit.lastname" v-bind="contactFieldsProperties('lastname')" />
                </v-col>
                <v-col>
                  <v-menu
                    ref="dateMenu"
                    :close-on-content-click="false"
                    :return-value.sync="contactToEdit.birth_date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="contactToEdit.birth_date"
                        v-bind="contactFieldsProperties('birth_date')"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker v-model="contactToEdit.birth_date" no-title scrollable color="primary">
                      <v-spacer />
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.dateMenu.save(contactToEdit.birth_date)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-divider />

          <v-card-text class="d-flex justify-end mt-4">
            <v-btn large color="primary" @click="cancelAddContact()">
              <v-icon class="mr-3">mdi-broom</v-icon>
              Cancel
            </v-btn>
            <v-btn large color="success" class="ml-4" @click="saveContact()">
              <v-icon class="mr-3">mdi-content-save</v-icon>
              Enregistrer
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div> -->
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';

import { contactFieldsProperties } from '@/utils/forms';
import { getLabel } from '@/utils';
import { useMainStore } from '../../store/index';

export default {
  setup () {
    const store = useMainStore();

    // const dialog = ref(false);

    // const errors = ref([]);

    // const closeAlert = () => {
    //   errors.value = [];
    // };

    const contactsHeaders = [
      {
        text: getLabel('name'),
        value: 'firstname',
        align: 'center'
      },
      {
        text: getLabel('lastname'),
        value: 'lastname',
        align: 'center'
      },
      {
        text: getLabel('birthday'),
        value: 'birth_date',
        align: 'center'
      }
      // {
      //   text: 'Actions',
      //   value: 'actions',
      //   align: 'center'
      // }
    ];

    const contacts = computed(() => store.collaborator.holdersRights);

    // const contactIndex = ref(null);

    // const contactToEdit = ref({
    //   firstname: null,
    //   lastname: null,
    //   birth_date: null
    // });

    // const cancelAddContact = () => {
    //   dialog.value = false;
    //   context.refs.form.resetValidation();

    //   contactToEdit.value = {
    //     firstname: null,
    //     lastname: null,
    //     birth_date: null
    //   };
    // };

    // const editContact = index => {
    //   contactToEdit.value = { ...contacts.value[index] };
    //   contactIndex.value = index;
    //   dialog.value = true;
    // };

    // const removeContact = index => {
    //   contacts.value.splice(index, 1);
    // };

    // const saveContact = () => {
    //   if (context.refs.form.validate()) {
    //     errors.value = [];
    //     dialog.value = false;
    //     if (contactIndex.value !== null) {
    //       // Editing a contact
    //       removeContact(contactIndex.value);
    //       contacts.value.splice(contactIndex.value, 0, contactToEdit.value);
    //     } else {
    //       // Creating a new contact
    //       contacts.value.push(contactToEdit.value);
    //     }
    //     context.refs.form.resetValidation();

    //     contactToEdit.value = {
    //       firstname: null,
    //       lastname: null,
    //       birth_date: null
    //     };
    //   } else {
    //     errors.value = ['Check fields'];
    //   }
    // };

    // dialog, errors, closeAlert, cancelAddContact, contactToEdit, editContact, removeContact, saveContact

    return { getLabel, contactFieldsProperties, contactsHeaders, contacts };
  }

};
</script>
